app.service('articlesCategory', function() {
	function setEvents(){
		$('.js-scroll-to-section').on('click', function() {
			var target = $(this).data('href');

			$.scrollTo($(`#scroll-target-${target}`).offset().top-70,200)
		});
	}
	function init() {
		setEvents();
	}

	return {
		init: init
	};
});
